import { Typography, Box, Popper } from "@mui/material";
import { useEffect } from "react";
import { ItemMenu } from "../../components/UI/ItemMenu";
import { IonRouterOutlet } from "@ionic/react";
import { PopUpWrapper } from "../../components/PopUpWrapper";
import { useState } from "react";
import { useHistory, createSearchParams, useLocation } from "react-router-dom";
import { usePageState, useQuery } from "../../Utils";
import { StringInputMODE } from "../../components/UI/StringInputMenu";
import { StringInputMenu } from "../../components/UI/StringInputMenu";
import { GetWindowState } from "../../Utils";
import { defaultReducer } from "../../Utils";
import { SelectInputMenu } from "../../components/UI/SelectInputMenu";
import { OXIMETER_ALARM_DELAY } from "../../ProSimulator/ProSimulator";
import { SelectProfileMenu } from "../../components/UI/SelectProfileMenu";
import { Translate, translate } from "react-i18nify";
import { ConfirmRiskyProfile } from "../../components/UI/ConfirmRiskyProfile";
import { CustomizeProfile } from "../../components/UI/CustomizeProfile";
import { colors } from "../../Style";
import { Tests } from "../../components/UI/Tests";
import { Test } from "../../components/UI/Test";
import { newPatientFlow } from "../../ProSimulator/NewPatientFlow";
export const Patient = (props) => {
  const history = useHistory();
  const location = useLocation();
  const state = GetWindowState();

  const defaultMenu = {
    LEFT: { label: "Back", route: "home" },
    UP: null,
    RIGHT: { label: "Select", route: "select", local: true },
    MIDDLE: null,
    DOWN: { label: "DOWN", route: "down", local: true },
  };

  const [popup, setPopUp] = useState(null);
  const [pageState, setPageState] = usePageState(
    defaultReducer,
    state
      ? state
      : {
          menu: { ...defaultMenu },
          window: null,
          oximeterSignalAlarmDelay: props.pro.oximeterSignalAlarmDelay,
          patient: { ...props.pro.patient },
          location: props.pro.location,
          activeItemIndex: 0,
          menuItems: generateMenuItems(props),
        }
  );

  const handleDown = (navigator, action, menu) => {
    if (pageState.window != null) {
      return;
    }
    setPageState((prev) => {
      let prevIndex = prev.activeItemIndex;
      let menuItems = prev.menuItems;
      let newActiveIndex =
        prevIndex < menuItems.length - 1 ? prevIndex + 1 : prevIndex;
      return { ...prev, activeItemIndex: newActiveIndex };
    });
  };

  const handleLeft = (navigator, action, menu) => {
    if (pageState.window != null) {
      // if (menu[action.button].route == "NAVIGATE_EDIT")
      //   setPageState((prevState) => {
      //     return {
      //       ...prevState,
      //       window: { ...prevState.window, mode: StringInputMODE.MODE_EDIT },
      //     };
      //   });

      return;
    }
    setPageState((prevState) => {
      return {
        ...prevState,
        window: {
          name: prevState.menuItems[prevState.activeItemIndex].window,
        },
      };
    });
  };

  const handleRight = (navigator, action, menu) => {
    if (
      pageState.window != null ||
      pageState.window?.name != null ||
      pageState.window?.name != undefined
    ) {
      // if (menu[action.button].route == "NAVIGATE_EDIT")
      //   setPageState((prevState) => {
      //     return {
      //       ...prevState,
      //       window: { ...prevState.window, mode: StringInputMODE.MODE_EDIT },
      //     };
      //   });

      return;
    }
    setPageState((prevState) => {
      return {
        ...prevState,
        windowName: prevState.menuItems[prevState.activeItemIndex].window,
        window: {},
      };
    });
  };

  const handleUp = (navigator, action, menu) => {
    if (pageState.window != null) {
      return;
    }
    setPageState((prev) => {
      let prevIndex = prev.activeItemIndex;
      let newActiveIndex = prevIndex > 0 ? prevIndex - 1 : prevIndex;
      return { ...prev, activeItemIndex: newActiveIndex };
    });
  };

  const updateNavigation = () => {
    setPageState((old) => {
      if (old.menuItems == null || old.menu == null) {
        return old;
      }
      const showUpButton = old.activeItemIndex > 0;
      const showDownButton = old.activeItemIndex < old.menuItems.length - 1;
      old.menu.UP = showUpButton
        ? { label: "UP", route: "UP", local: true }
        : null;
      old.menu.DOWN = showDownButton
        ? { label: "DOWN", route: "DOWN", local: true }
        : null;
      return old;
    });
  };
  const setWindowState = (state, windowState) => {
    setPageState((prev) => {
      return {
        ...prev,
        window: { ...prev.window, state: windowState, menu: state},
      };
    });
    props.navigation.setMenu(state);
  };

  const renderPopUp = (state) => {
    let popUp = null;
    switch (state.windowName) {
      case "newPatient":
      case "newNoSignalDelay":
      case "selectNewProfile":
      case "confirmRiskyProfileNew":
        popUp = newPatientFlow(state, setWindowState, pageState, setPageState, defaultMenu, props, history)
        break;
      case "noSignalDelay":
        popUp = (
          <SelectInputMenu
            values={[
              OXIMETER_ALARM_DELAY.OXIMETER_DELAY_30,
              OXIMETER_ALARM_DELAY.OXIMETER_DELAY_15,
              OXIMETER_ALARM_DELAY.OXIMETER_DELAY_5,
              OXIMETER_ALARM_DELAY.OXIMETER_DELAY_1,
              OXIMETER_ALARM_DELAY.OXIMETER_DELAY_0,
            ]}
            name={"noSignalDelay"}
            label={translate("SignalAlarmDelay")}
            onComplete={(newValue) => {
              props.pro.setOximeterSignalAlarmDelay(newValue);
              setPageState((prev) => {
                return {
                  ...prev,
                  oximeterSignalAlarmDelay: newValue,
                  windowName: null,
                  window: null,
                  updated: null,
                };
              });
            }}
            onCancel={() => {
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                  updated: null,
                };
              });
            }}
            value={
              state.updated?.oximeterSignalAlarmDelay
                ? state.updated?.oximeterSignalAlarmDelay
                : state?.oximeterSignalAlarmDelay
            }
            format={(data) => data / 60 + " min"}
            setState={setWindowState}
            menu={state?.window?.menu}
            state={state?.window?.state}
          />
        );
        break;
      case "selectProfile":
        popUp = (
          <SelectProfileMenu
            profiles={[...props.pro.defaultProfiles]}
            name={"selectProfile"}
            label={translate("Profile")}
            lockedValues={["FlowResponse"]}
            onComplete={(profile) => {
              if (isRiskyProfile(profile)) {
                profile.isRisky = true;
                setPageState((prev) => {
                  return {
                    ...prev,
                    windowName: "confirmRiskyProfile",
                    window: null,
                    riskyProfile: profile,
                  };
                });
              } else {
                props.pro.setProfile(profile);
                setPageState((prev) => {
                  return {
                    ...prev,
                    windowName: null,
                    window: null,
                    updated: null,
                  };
                });
              }
            }}
            onCancel={() => {
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                  updated: null,
                };
              });
            }}
            value={
              state.updated?.oximeterSignalAlarmDelay
                ? state.updated?.oximeterSignalAlarmDelay
                : state?.oximeterSignalAlarmDelay
            }
            format={(data) => data}
            setState={setWindowState}
            menu={state?.window?.menu}
            state={state?.window?.state}
          />
        );
        break;
      case "customizeProfile":
        popUp = (
          <CustomizeProfile
            name={"customizeProfile"}
            label={translate("CustomizeProfile")}
            lockedValues={["FlowResponse"]}
            onComplete={(profile) => {
              if (isRiskyProfile(profile)) {
                profile.isRisky = true;
                setPageState((prev) => {
                  return {
                    ...prev,
                    windowName: "confirmRiskyProfile",
                    window: null,
                    riskyProfile: profile,
                  };
                });
              } else {
                profile.isRisky = false;
                props.pro.setProfile(profile);
                setPageState((prev) => {
                  return {
                    ...prev,
                    windowName: null,
                    window: null,
                    updated: null,
                  };
                });
              }
            }}
            onCancel={() => {
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                };
              });
            }}
            value={{ ...props.pro.profile }}
            format={(data) => data}
            setState={setWindowState}
            menu={state?.window?.menu}
            state={state?.window?.state}
          />
        );
        break;
      case "confirmRiskyProfile":
        popUp = (
          <ConfirmRiskyProfile
            message={
              <Typography
                variant="h6"
                sx={{ color: colors().COLORS_ALARM_MEDIUM, fontWeight: "bold" }}
              >
                <Translate value={"ConfirmCritical"} />
              </Typography>
            }
            name={"confirmRiskyProfile"}

            onComplete={(state) => {
              props.pro.setProfile(pageState.riskyProfile);
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                  updated: null,
                };
              });
            }}
            onCancel={() => {
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                };
              });
            }}
            setState={setWindowState}
            menu={state?.window?.menu}
            state={state?.window?.state}
          />
        );
        break;
      case "tests":
        popUp = (
          <Tests
            name={"deviceStatus"} // JAT why is this device status?
            setState={setWindowState}
            menu={state?.window?.menu}
            state={state?.window?.state}
            onComplete={(testProfile)=>{
              setPageState((prev) => {
                return {
                  ...prev,
                  window:{name:"test",testProfile:testProfile},
                  windowName:"test",
                };
              });  
            }}
            onCancel={() => {
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                };
              });
            }}
          />
        );
        break;
      case "test":
        popUp = (
          <Test
            name={"test"}
            setState={setWindowState}
            menu={state?.window?.menu}
            pro={props.pro}
            testProfile={state?.window?.testProfile}
            state={state?.window?.state}
            onComplete={(data) => {
              props?.pro?.setTestMode(data);
              history.push("/home")
            }}
            onCancel={() => {
              setPageState((prev) => {
                return {
                  ...prev,
                  window:{name:"tests"},
                };
              });
            }}
          />
        );
        break;

          
    }
    return popUp;
  };

  const newPatientComplete = (state) => {
    setPageState((prev) => {
      return {
        ...prev,
        updated: { patient: { patientId: state.newValue } },
        windowName: "newName",
        window: null,
      };
    });
  };

  const newNameComplete = (state) => {
    setPageState((prev) => {
      let patient = prev.updated.patient;
      patient.patientName = state.newValue;
      return {
        ...prev,
        updated: { ...prev.updated, patient: patient },
        windowName: "newLocation",
        window: null,
      };
    });
  };

  const localNavigation = (navigator, action, menu) => {
    if (action.type == "CLICK") {
    }
    if (pageState.window?.state?.windowNavigation != null) {
      pageState.window?.state?.windowNavigation(
        navigator,
        action,
        menu,
        pageState?.window?.state
      );
      return;
    }

    if (action.type == "CLICK") {
      switch (action.button) {
        case "DOWN":
          handleDown(navigator, action, menu);
          break;
        case "LEFT":
          handleLeft(navigator, action, menu);
          break;
        case "UP":
          handleUp(navigator, action, menu);
          break;
        case "RIGHT":
          handleRight(navigator, action, menu);
          break;
      }
    }
  };
  useEffect(() => {
    let menuItems = generateMenuItems(props);
    setPageState((prev) => {
      return { ...prev, menuItems: menuItems };
    });
  }, [pageState.oximeterSignalAlarmDelay, pageState.location]);
  
  useEffect(() => {
    updateNavigation();
  }, [pageState.activeItemIndex]);

  useEffect(() => {
    const state = pageState;
    // if(state.window){
    //   state.window.menu=null;
    // }

    const searchParams = new URLSearchParams();
    searchParams.append("windowState", JSON.stringify(state));
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });

    if (
      pageState?.window?.menu == null ||
      pageState?.window?.menu == undefined
    ) {
      props.navigation.setMenu(pageState.menu);
    }
    props.navigation.addLocalNavigation(localNavigation);
    return () => {
      props.navigation.addLocalNavigation(null);
    };
  }, [pageState]);
  
  useEffect(() => {
    let pop = renderPopUp(pageState);
    setPopUp(pop);
  }, [pageState.windowName, pageState.window]);

  return (
    <PopUpWrapper popup={popup}>
      <ItemMenu
        margin={5}
        activeItemIndex={pageState.activeItemIndex}
        width="60%"
        menuItems={pageState.menuItems}
      />
    </PopUpWrapper>
  );
};

const generateMenuItems = (props) => {
  return [
    { label: translate("ViewCustomizeCurrentProfile"), window: "customizeProfile" },
    {
      label: translate("SignalAlarmDelay"),
      value: props.pro.oximeterSignalAlarmDelay / 60 + " min",
      window: "noSignalDelay",
    },
    { label: translate("ChooseNewProfile"), window: "selectProfile" },
    { label: translate("NewPatient"), window: "newPatient" },
    {
      label: translate("PerformWalkingTest"),
      window: "tests",
    },
  ];
};

const isRiskyProfile = (profile) => {
  if (profile.minSpO2 < 85 || profile.maxPulse > 150) {
    return true;
  }
  return false;
};
